export function NotFoundPage() {
  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <div className="text-center max-w-sm">
        <div className="w-12 h-12 mx-auto mb-4 rounded-full bg-[#f3f4f6] flex items-center justify-center">
          <svg
            className="w-6 h-6 text-[#6b7280]"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={1.5}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9 5.25h.008v.008H12v-.008z"
            />
          </svg>
        </div>
        <h1 className="text-lg font-semibold text-[#111827] mb-1">Page not found</h1>
        <p className="text-sm text-[#6b7280] mb-6">
          The page you're looking for doesn't exist.
        </p>
        <a
          href="https://soljar.xyz"
          className="text-sm text-[#111827] hover:underline font-medium"
        >
          Go to soljar →
        </a>
      </div>
    </div>
  )
}
